import Block from "base/Block";
import Swiper from 'swiper';

class OffersSlider extends Block {
	static get blockName() {
		return 'b-offers-slider';
	}

	onInit() {
		new Swiper('.' + this.blockName + '__content', {
			slidesPerView: 'auto',
			spaceBetween: 20,
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20
				},
				920: {
					slidesPerView: 3,
					spaceBetween: 24
				},
				1280: {
					slidesPerView: 4,
					spaceBetween: 24
				},
			},
		});
	}
}

Block.register(OffersSlider);

export default OffersSlider;
